import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HospitalContractListsComponent } from './hospital-contract-lists.component';
import { AngularMaterialModule } from '../../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../../pipes/index";



@NgModule({
  declarations: [HospitalContractListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule, PipesModule
  ],
  exports: [HospitalContractListsComponent]
})
export class HospitalContractListsModule { }
